import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HomePage} from '../home/home.page';
import {MenuPage} from '../menu/menu.page';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {NavigationService} from 'src/app/services/navigation.service';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import {NavController} from '@ionic/angular';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.page.html',
	styleUrls: ['privacy.page.scss']
})
export class PrivacyPage implements OnInit {
	static url = 'privacy';
	public textArray = [
		{
			title: this.translate.instant('info_page.allergensTitle'),
			info: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
			isOpen: false
		},
		{
			title: this.translate.instant('info_page.privacyTitle'),
			info: this.translate.instant('privacy_page.data'),
			isOpen: false
		},
		{
			title: this.translate.instant('info_page.impressumTitle'),
			info: this.translate.instant('impressum_page.data'),
			isOpen: false
		}
	];
	public showArrayInfo$ = new BehaviorSubject(this.textArray);
	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private translate: TranslateService,
		private navCtrl: NavController
	) {}
	ngOnInit(): void {
		if (this.repository._venue) {
			const venue = this.repository._venue;
			let value = this.showArrayInfo$.value;
			value[0].info = venue?.legal?.terms?.length > 0 ? venue?.legal?.terms : value[0]?.info;
			value[1].info = venue?.legal?.privacy?.length > 0 ? venue?.legal?.privacy : value[1]?.info;
			value[2].info = venue?.legal?.imprint?.length > 0 ? venue?.legal?.imprint : value[2]?.info;
			this.showArrayInfo$.next(value);
		}

		this.translate.onLangChange.subscribe(v => {
			if (this.repository._venue) {
				const venue = this.repository._venue;
				let value = this.showArrayInfo$.value;
				value[0].info = venue?.legal?.terms?.length > 0 ? venue?.legal?.terms : value[0]?.info;
				value[1].info = venue?.legal?.privacy?.length > 0 ? venue?.legal?.privacy : value[1]?.info;
				value[2].info = venue?.legal?.imprint?.length > 0 ? venue?.legal?.imprint : value[2]?.info;
				this.showArrayInfo$.next(value);
			} else {
				this.showArrayInfo$.next([
					{
						title: this.translate.instant('info_page.allergensTitle'),
						info: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
						isOpen: false
					},
					{
						title: this.translate.instant('info_page.privacyTitle'),
						info: this.translate.instant('privacy_page.data'),
						isOpen: false
					},
					{
						title: this.translate.instant('info_page.impressumTitle'),
						info: this.translate.instant('impressum_page.data'),
						isOpen: false
					}
				]);
			}
		});

		this.showArrayInfo$.subscribe(v => console.log(v));
	}

	async goBack() {
		// if (this.repository._order === null) {
		// 	await this.navigationService.home();
		// } else {
		// 	await this.navigationService.menu();
		// }
		this.navCtrl.back();
	}
	changeIsOpen(index: number) {
		let arrayInfo = this.showArrayInfo$.value.map((it, i) => {
			if (i == index) {
				it.isOpen = !it.isOpen;
			}
			return it;
		});
		this.showArrayInfo$.next(arrayInfo);
	}
}
